import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import './CrisisSupport.css';

const CrisisSupport = () => {
  const [expanded, setExpanded] = useState(false);

  const toggleCrisis = () => {
    setExpanded(!expanded);
  };

  return (
    <section className="section-crisis-support">
      <div className="container">
        <div 
          className={`crisis-support-card ${expanded ? 'expanded' : ''}`}
          onClick={toggleCrisis}
        >
          <div className="crisis-header">
            <div className="crisis-main-content">
              <h3 className="heading-2">Need Immediate Support?</h3>
            </div>
            <div className="expand-icon">
              {expanded ? <ChevronUp size={24} /> : <ChevronDown size={24} />}
            </div>
          </div>
          
          {expanded && (
            <div className="crisis-expanded-content">
              <div className="crisis-emergency-row">
                <div className="emergency-item">
                  <h4>Emergency</h4>
                  <a href="tel:000" className="emergency-number">000</a>
                </div>
              </div>
              
              <div className="crisis-services-grid">
                <div className="crisis-service-item">
                  <h4><a href="https://www.lifeline.org.au" target="_blank" rel="noopener noreferrer" className="service-title-link">Lifeline</a></h4>
                  <div className="service-links">
                    <a href="tel:131114" className="phone-link">13 11 14</a>
                    <a href="https://www.lifeline.org.au/crisis-chat/#" target="_blank" rel="noopener noreferrer" className="chat-link">Chat</a>
                  </div>
                </div>
                
                <div className="crisis-service-item">
                  <h4><a href="https://www.beyondblue.org.au" target="_blank" rel="noopener noreferrer" className="service-title-link">Beyond Blue</a></h4>
                  <div className="service-links">
                    <a href="tel:1300224636" className="phone-link">1300 22 4636</a>
                    <a href="https://www.beyondblue.org.au/get-support/talk-to-a-counsellor/chat" target="_blank" rel="noopener noreferrer" className="chat-link">Chat</a>
                  </div>
                </div>
                
                <div className="crisis-service-item">
                  <h4><a href="https://www.health.nsw.gov.au/mentalhealth/Pages/Mental-Health-Line.aspx" target="_blank" rel="noopener noreferrer" className="service-title-link">Mental Health Line</a></h4>
                  <div className="service-links">
                    <a href="tel:1800011511" className="phone-link">1800 011 511</a>
                  </div>
                </div>
                
                <div className="crisis-service-item">
                  <h4><a href="https://kidshelpline.com.au" target="_blank" rel="noopener noreferrer" className="service-title-link">Kids Helpline</a></h4>
                  <div className="service-links">
                    <a href="tel:1800551800" className="phone-link">1800 55 1800</a>
                    <a href="https://kidshelpline.com.au/get-help/webchat-counselling" target="_blank" rel="noopener noreferrer" className="chat-link">Chat</a>
                  </div>
                </div>
                
                <div className="crisis-service-item">
                  <h4><a href="https://www.suicidecallbackservice.org.au" target="_blank" rel="noopener noreferrer" className="service-title-link">Suicide Call Back Service</a></h4>
                  <div className="service-links">
                    <a href="tel:1300659467" className="phone-link">1300 659 467</a>
                    <a href="https://www.suicidecallbackservice.org.au/phone-and-online-counselling/" target="_blank" rel="noopener noreferrer" className="chat-link">Chat</a>
                  </div>
                </div>
                
                <div className="crisis-service-item">
                  <h4><a href="https://www.13yarn.org.au" target="_blank" rel="noopener noreferrer" className="service-title-link">13YARN</a></h4>
                  <div className="service-links">
                    <a href="tel:139276" className="phone-link">13 92 76</a>
                  </div>
                </div>
                
                <div className="crisis-service-item">
                  <h4><a href="https://www.1800respect.org.au" target="_blank" rel="noopener noreferrer" className="service-title-link">1800 RESPECT</a></h4>
                  <div className="service-links">
                    <a href="tel:1800737732" className="phone-link">1800 737 732</a>
                    <a href="https://1800respect.org.au/help-and-support" target="_blank" rel="noopener noreferrer" className="chat-link">Chat</a>
                  </div>
                </div>
                
                <div className="crisis-service-item">
                  <h4><a href="https://au.reachout.com" target="_blank" rel="noopener noreferrer" className="service-title-link">Reachout (ages 16-25)</a></h4>
                  <div className="service-links">
                    <a href="https://au.reachout.com/peerchat" target="_blank" rel="noopener noreferrer" className="chat-link">Chat</a>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default CrisisSupport;